import { useOutletContext } from 'react-router-dom';

import DrugScreenWarningModal from '@/components/DrugScreenWarningModal';
import useRecordDrugScreen from '@/hooks/useRecordDrugScreen';
import { type Encounter } from '@/types/encounter';
import Button from '@/ui/components/Button';
import DataList, { DataRow } from '@/ui/components/DataList';
import DualTime from '@/ui/components/DualTime';
import { getDrugScreenMeta } from '@/utils/drugScreenMeta';
import formatStaffName from '@/utils/formatStaffName';
import snakeCaseToTitleCase from '@/utils/snakeToTitleCase';

import hasDrugScreenCard from './hasDrugScreenCard';

const DrugScreenSection = () => {
  const { encounter } = useOutletContext<{ encounter: Encounter }>();
  const { recordDrugScreen, warningModalProps } = useRecordDrugScreen(encounter);

  if (!hasDrugScreenCard(encounter)) return null;

  return (
    <>
      {encounter?.drug_screens?.length ? (
        <DataList>
          <DataRow label="Result" sensitive>
            {getDrugScreenMeta(encounter.drug_screens[0]).emoji}{' '}
            {snakeCaseToTitleCase(encounter.drug_screens[0].result)}
          </DataRow>

          {!!(
            encounter.drug_screens[0].conducted_by?.first_name &&
            encounter.drug_screens[0].conducted_by?.last_name
          ) && (
            <DataRow label="Conducted By">
              {formatStaffName({ staff: encounter.drug_screens[0].conducted_by })}
            </DataRow>
          )}

          {!!encounter.drug_screens[0].kind && (
            <DataRow label="Kind">{snakeCaseToTitleCase(encounter.drug_screens[0].kind)}</DataRow>
          )}

          {!!encounter.drug_screens[0].occurred_at && (
            <DataRow label="Occurred At">
              <DualTime dateTime={new Date(encounter.drug_screens[0].occurred_at)} />
            </DataRow>
          )}
        </DataList>
      ) : (
        <Button size="sm" title="Record Drug Screen" onClick={recordDrugScreen}>
          Record Drug Screen
        </Button>
      )}

      {!encounter?.drug_screens?.length && warningModalProps && (
        <DrugScreenWarningModal {...warningModalProps} />
      )}
    </>
  );
};

export default DrugScreenSection;
